<script setup>
import { computed } from 'vue';
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useI18n } from 'vue-i18n';
import Spinner from 'shared/components/Spinner.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({
      positive: 0,
      neutral: 0,
      negative: 0,
    }),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

ChartJS.register(ArcElement, Tooltip, Legend);

const { t } = useI18n();

const chartData = computed(() => ({
  labels: [
    t('CAPTAIN_ANALYTICS.SENTIMENT.POSITIVE'),
    t('CAPTAIN_ANALYTICS.SENTIMENT.NEUTRAL'),
    t('CAPTAIN_ANALYTICS.SENTIMENT.NEGATIVE'),
  ],
  datasets: [
    {
      data: [
        props.data.positive || 0,
        props.data.neutral || 0,
        props.data.negative || 0,
      ],
      backgroundColor: [
        'rgb(34, 197, 94)', // green
        'rgb(148, 163, 184)', // slate
        'rgb(239, 68, 68)', // red
      ],
      borderWidth: 0,
    },
  ],
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        padding: 20,
      },
    },
  },
};

const total = computed(
  () =>
    (props.data.positive || 0) +
    (props.data.neutral || 0) +
    (props.data.negative || 0)
);
</script>

<template>
  <div
    class="flex flex-col p-4 rounded-xl bg-n-solid-2 shadow outline-1 outline outline-n-container"
  >
    <h3 class="text-base font-medium text-n-slate-12 mb-4">
      {{ $t('CAPTAIN_ANALYTICS.SENTIMENT_DISTRIBUTION') }}
    </h3>
    <div v-if="isLoading" class="flex items-center justify-center h-64">
      <Spinner />
    </div>
    <div
      v-else-if="total === 0"
      class="flex items-center justify-center h-64 text-n-slate-11"
    >
      {{ $t('CAPTAIN_ANALYTICS.NO_DATA') }}
    </div>
    <div v-else class="h-64">
      <Doughnut :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>
